import Platform from 'platform';
import gtmService from './gtmService';
import device from './device';
import { GTM_EVENT_TYPES, baseGtmAnalyticsConstants } from './constants';

export default (async () => {
  /**
   * This method is used to get the users timezone offset from UTC in hours
   * @type {{getBrowserTZ(): *, UTCOffset: number, UTCOffsetT: string, hasDST: boolean}}
   */
  const clientTimezone = {
    UTCOffset: 0, // Browser time offset from UTC in minutes
    UTCOffsetT: '+0000S', // Browser time offset from UTC in '±hhmmD' form
    hasDST: false, // Browser time observes DST
    // Determine browser's timezone and DST
    getBrowserTZ() {
      const self = clientTimezone;

      // Determine UTC time offset
      const now = new Date();
      const date1 = new Date(now.getFullYear(), 1 - 1, 1, 0, 0, 0, 0); // Jan
      const diff1 = -date1.getTimezoneOffset();
      self.UTCOffset = diff1;

      // Determine DST use
      const date2 = new Date(now.getFullYear(), 6 - 1, 1, 0, 0, 0, 0); // Jun
      let diff2 = -date2.getTimezoneOffset();
      if (diff1 !== diff2) {
        self.hasDST = true;
        if (diff1 - diff2 >= 0) {
          self.UTCOffset = diff2;
        } // East of GMT
      }

      // Convert UTC offset to ±hhmmD form
      diff2 = (diff1 < 0 ? -diff1 : diff1) / 60;
      const hr = Math.floor(diff2);
      const min = diff2 - hr;
      // eslint-disable-next-line no-mixed-operators
      diff2 = hr * 100 + min * 60;
      self.UTCOffsetT = (diff1 < 0 ? '-' : '+') + (hr < 10 ? '0' : '') + diff2.toString() + (self.hasDST ? 'D' : 'S');

      return self.UTCOffset / 60; // Converting minutes to hours as expected by GTM event
    },
  };

  /**
   * This method parses the appVersion (window.navigator.appVersion) to get the user's platform
   * @returns {string} one of { Unknown OS, Windows, MacOS, UNIX, Linux, Android, iOS }
   */
  const getOSFromBrowser = () => {
    let OSName = 'Unknown OS';
    if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
    if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS';
    if (navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX';
    if (navigator.appVersion.indexOf('Linux') !== -1) OSName = 'Linux';
    if (navigator.userAgent.indexOf('Android') !== -1) OSName = 'Android';
    if (navigator.userAgent.indexOf('like Mac') !== -1) OSName = 'iOS';
    return OSName;
  };

  const navigatorObject = window.navigator;
  const { name } = Platform;

  const browserParams = {
    app_id: baseGtmAnalyticsConstants.app_id,
    app_version: '1.0.0',
    userTimezoneOffset: clientTimezone.getBrowserTZ(),
    webBrowser: name,
    deviceType: device.getDeviceType(navigatorObject.userAgent),
    operatingSystemCode: getOSFromBrowser(),
  };
  gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.GLOBAL_LAUNCH, payload: browserParams });
  return {
    browserParams,
  };
})();
